module.exports = __webpack_public_path__ + "img/RTI_Logo_Black.cc651558.svg";